import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "Courses", href: "#courses" },
  { label: "About", href: "#about" },
  { label: "Voices", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="site-navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-white/70 backdrop-blur-xl border-b border-border"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-baseline gap-2 group"
        >
          <span className="font-deva text-3xl text-primary leading-none">न</span>
          <span className="font-display font-extrabold text-lg tracking-tight text-foreground leading-none">
            Navjeevan
          </span>
        </a>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="font-body text-sm text-foreground/80 hover:text-foreground link-underline"
            >
              {l.label}
            </button>
          ))}
        </div>

        <button
          data-testid="nav-enquire-btn"
          onClick={() => go("#contact")}
          className="rounded-full bg-foreground text-background px-6 py-2.5 text-sm font-medium hover:bg-primary transition-colors duration-300"
        >
          Enquire
        </button>
      </nav>
    </motion.header>
  );
}
